// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__zCrWF","title":"ClientInsurance_title__eMFSs","itemText":"ClientInsurance_itemText__xyRT2"};